/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextArticleTIcon16Light = forwardRef('TextArticleTIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H4v3.5a.5.5 0 0 1-1 0V3H1.5a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M8.5 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z" }),
        React.createElement("path", { d: "M8 6.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M2.5 9a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Z" }),
        React.createElement("path", { d: "M2.5 12a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Z" })));
});
